import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import requests from '../../utils/aqua/Request';
import moment from 'moment';
import ButtonCsvDownload from '../../components/Button/ButtonCsvDownload';
import DesktopDatePickerCommon from '../../components/DesktopDatePicker/DesktopDatePickerCommon';

const P01Prg101Buhin003: React.FC = () => {
  //変数定義
  //処理日(始点)
  const [startdate, setstartdate] = useState<Date | undefined>(new Date());
  //処理日(終点)
  const [enddate, setenddate] = useState<Date | undefined>(new Date());

  // api 用のパラメータを設定する
  const apiUrl = String(process.env.REACT_APP_APIURL_AP00447 + requests.p01Prg001syogodownload)
  const apiKey = String(process.env.REACT_APP_APIKEY_AP00447)
  const DLFileHeader = ['processcode', 'date', 'time', 'workcode', 'datafrom', 'param1', 'param2',];
  const DLFileName1 = "syogo_ukeire_" + moment(startdate).format("YYYY-MM-DD") + "-" + moment(enddate).format("YYYY-MM-DD") + ".csv"
  const DLFileName2 = "syogo_haraidashi_" + moment(startdate).format("YYYY-MM-DD") + "-" + moment(enddate).format("YYYY-MM-DD") + ".csv"
  const apiParam1 = {
    processcode: "AF710",
    startdate: moment(startdate).format("YYYY-MM-DD"),
    enddate: moment(enddate).format("YYYY-MM-DD"),
  };
  const apiParam2 = {
    processcode: "AF720",
    startdate: moment(startdate).format("YYYY-MM-DD"),
    enddate: moment(enddate).format("YYYY-MM-DD"),
  };
  return (
    <Stack spacing={1} direction="column" >
      <div>HDT補強材ログ出力</div>
      <Stack spacing={2} direction="row">
        <DesktopDatePickerCommon
          label="処理日(始点)"
          value={startdate}
          onChange={(newSnouki: any) => { setstartdate(newSnouki); }}
        />
        <DesktopDatePickerCommon
          label="処理日(終点))"
          value={enddate}
          onChange={(newSnouki: any) => { setenddate(newSnouki); }}
        />
      </Stack>
      <Stack spacing={2} direction="row">
        {/* CSVダウンロード・ボタン */}
        <ButtonCsvDownload
          apiParam={apiParam1}
          apiUrl={apiUrl}
          apiKey={apiKey}
          DLFileHeader={DLFileHeader}
          DLFileName={DLFileName1}
          buttonName="受入ログ出力"
        />
        {/* CSVダウンロード・ボタン */}
        <ButtonCsvDownload
          apiParam={apiParam2}
          apiUrl={apiUrl}
          apiKey={apiKey}
          DLFileHeader={DLFileHeader}
          DLFileName={DLFileName2}
          buttonName="払出ログ出力"
        />
      </Stack>
      <div>（っ'-')╮ =͟͟͞͞📚ﾌﾞｫﾝ.</div>
    </Stack>
  )
}

export default P01Prg101Buhin003